/**============================================================
*   [inquiryAcceptance]
*   description : お問い合わせフォームの承認ボタン処理
============================================================*/
const inquiryForm = document.getElementById('inquiryForm');
const acceptance = document.querySelector('.wpcf7-acceptance');

if (inquiryForm && acceptance) {
  document.addEventListener('DOMContentLoaded', function () {
    const listItem = acceptance.querySelector('.wpcf7-list-item');
    const label = acceptance.querySelector('label');
    const checkIcon = acceptance.querySelector('.wpcf7-list-item-label');
    let listItemText = checkIcon.innerHTML;
    const newElement = document.createElement('span');
    label.className = 'c-text-lg';
    listItem.className = 'c-form-checkbox';
    checkIcon.className = 'c-form-checkbox__icon';
    newElement.innerHTML = listItemText;
    checkIcon.innerHTML = '';
    label.appendChild(newElement);

    // 確認画面から遷移した場合ボタンのdisabledを解除
    const referrer = document.referrer;
    if (referrer.indexOf('/inquiry/confirm/') != -1) {
      const submit = document.querySelector('.wpcf7-submit');
      submit.disabled = false;
    }
  });
}
